(function () {
  if (window.Shopify && window.Shopify.designMode) return;

  var placeholders = document.querySelectorAll('.lazy-section-placeholder');
  if (!placeholders.length) return;

  var queued = new Map();
  var scheduled = false;

  function runScripts(container) {
    container.querySelectorAll('script').forEach(function (oldScript) {
      var src = oldScript.getAttribute('src');
      if (src && document.querySelector('script[src="' + src + '"]')) {
        oldScript.remove();
        return;
      }
      var newScript = document.createElement('script');
      Array.prototype.forEach.call(oldScript.attributes, function (attr) {
        newScript.setAttribute(attr.name, attr.value);
      });
      if (!src) newScript.textContent = oldScript.textContent;
      oldScript.parentNode.replaceChild(newScript, oldScript);
    });
  }

  function replaceSection(sectionId, html) {
    var placeholder =
      queued.get(sectionId) ||
      document.querySelector('.lazy-section-placeholder[data-section-id="' + sectionId + '"]');
    queued.delete(sectionId);
    if (!placeholder || !html) return;

    var outer = placeholder.closest('.shopify-section') || placeholder;
    var temp = document.createElement('div');
    temp.innerHTML = html.trim();
    var newSection = temp.firstElementChild;
    if (!newSection) return;

    outer.replaceWith(newSection);
    runScripts(newSection);
  }

  function flush() {
    scheduled = false;
    var ids = Array.from(queued.keys());
    if (!ids.length) return;

    fetch(window.location.pathname + '?sections=' + ids.join(',') + '&lazy=1')
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        ids.forEach(function (id) {
          replaceSection(id, data[id]);
        });
      })
      .catch(function (err) {
        console.error('[LazySection] Failed batch:', ids, err);
      });
  }

  function scheduleFlush() {
    if (scheduled) return;
    scheduled = true;
    queueMicrotask(flush);
  }

  var observer = new IntersectionObserver(
    function (entries) {
      var any = false;
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var sectionId = entry.target.dataset.sectionId;
        if (!sectionId || queued.has(sectionId)) return;
        observer.unobserve(entry.target);
        queued.set(sectionId, entry.target);
        any = true;
      });
      if (any) scheduleFlush();
    },
    { rootMargin: '400px' }
  );

  placeholders.forEach(function (el) {
    observer.observe(el);
  });
})();
